<template>
	<header class="titlebar">
		<div class="menu" @click.stop="openSidebar">
			<IconMenu />
		</div>
		<h1 class="title">{{ titleWithFallback }}</h1>
		<User align="right" />
	</header>
</template>

<script>
import IconMenu from 'mdi-vue/Menu'
import User from '@/components/User'

export default {
	name: 'Titlebar',
	props: {
		title: String,
	},
	computed: {
		titleWithFallback() {
			return this.title || this.$route.name
		},
	},
	methods: {
		openSidebar() {
			this.$store.commit('sidebar/open')
		},
	},
	components: {
		IconMenu,
		User,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.titlebar {
	@extend %flex-row;
	height: 2rem;
	margin-bottom: 1rem;

	.menu {
		@include square(1.75rem);
		margin-right: 0.5rem;
		cursor: pointer;
	}

	.title {
		font-size: 1.5rem;
		font-weight: 300;
		color: $col-primary;
		margin: 0;
		flex-grow: 1;
	}

	@include mq-max(md) {
		.user {
			display: none;
		}
	}

	@include mq(md) {
		margin-bottom: 2rem;
		.menu {
			margin-right: 1rem;
		}
	}

	@include mq(lg) {
		.menu {
			display: none;
		}
	}
}
</style>
